import { useMediaQuery } from "@mui/material";
import React from "react";
import { useLocation } from "react-router-dom";

export default function HospitalityIndustryDetail() {
  const state = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");

  const data = state?.state.news;

  // Extracting YouTube video ID from URL

  return (
    <div className="container-fluid justify-content-center ">
      <div className="mt-3">
        <div
          className="card shadow-md p-4 mt-3 mb-4 about-content"
          style={{ marginLeft: "14px" }}
        >
          <h4 className="fw-bold mb-4">{data.name}</h4>
          <div
            className="video-container"
            style={{ width: "100%", height: isMobile ? "100%" : "100vh" }}
          >
            <iframe
              style={{
                width: isMobile ? "100%" : "100%",
                height: isMobile ? "50%" : "100%",
              }}
              src="https://www.youtube.com/embed/TqrjeXTZkVA?si=rVJvEEtFvrxQP9jq"
              title="Podcast Industry Video"
              allowFullScreen
              className="rounded"
            ></iframe>
          </div>
          <div className="mt-3 p-text">
            <p>
              Connect all your data, with all your teams, all on one integrated,
              AI-driven platform. Get started today with Starter Suite, the
              all-in-one CRM app for small business. Scale seamlessly, however
              large you grow.Connect all your data, with all your teams, all on
              one integrated, AI-driven platform. Get started today with Starter
              Suite, the all-in-one CRM app for small business. Scale
              seamlessly, however large you grow.
            </p>
          </div>
        </div>
      </div>

      {/* Full-width and full-height YouTube Video */}
    </div>
  );
}
